import { useEffect, useRef } from "react";
import { message } from "antd";
import { YhForm } from "@/components/YhFormBox";
import { IYhForm, IYhFormRef, FormItemTypeEnum } from "@/components/YhFormBox/Types";
import { getFormValidatorErrText } from "@/utils/utils";
import { IRestaurantDetial } from "../restaurant/restaurantTypes";
import { restaurantService } from "../restaurant/restaurantServices";
import { YHModal } from "@/components/YHModal";

export function DetailDrawer({
    visible,
    onCancel
}: any) {
    const formRef = useRef<IYhFormRef>();

    useEffect(() => {
        console.log(visible)
    }, [])
    const onSubmit = async () => {
        // setIVisibleDrawer()
        formRef.current?.validateFields().then(async (val: any) => {
            let { retData } = await restaurantService.insert(val)
            onCancel();
            message.success("餐厅新增成功")
        }).catch(err => {
            message.warning(getFormValidatorErrText(err));
        })
    }

    const formConfig: IYhForm<IRestaurantDetial> = {
        formRef,
        labelCol: { span: 6 },
        formValues: {},
        items: [
            {
                type: FormItemTypeEnum.Input,
                span: 18,
                fieldLabel: "餐厅名称",
                fieldName: "name",
                rules: [{ required: true, message: "请输入餐厅名称" }]
            },
            {
                type: FormItemTypeEnum.Input,
                span: 18,
                fieldLabel: "餐厅地址",
                fieldName: "address",
                rules: [{ required: true, message: "请输入餐厅地址" }]
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "联系人",
                fieldName: "contact",
                span: 18,
                rules: [{ required: true, message: "请输入联系人" }]
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "联系电话",
                fieldName: "phone",
                span: 18,
                rules: [{ required: true, message: "请输入联系电话" }]
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "餐厅介绍",
                fieldName: "note",
                span: 18,
            }
        ]
    }
    return (
        <YHModal
            {...{
                title: `餐厅管理新增`,
                visible,
                onCancel,
                okText: "保存",
                onOk: onSubmit,
                showFooter: true,
                mask: false
            }}
        >
            <YhForm {...formConfig} />
        </YHModal>
    )
}